import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#259354" }}>Brief</span>
            </h2>
            <p>
              Mart Book is an interactive platform designed for modern-day
              farmers, where they can pre-book their animals, or sell and buy
              animals through the convenience of their mobile devices.
            </p>
            <h2 style={{ color: "#000" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#259354" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#259354" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#259354" }}> Mobile Application</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
